<template>
  <div class="device-tianmu-child-device">
    <div class="border_title">
      {{ $t('tianmu.childDevice') }}
    </div>
    <div class="device-tianmu-child-device-container">
      <OppleDeviceCard v-for="(card, index) in deviceCardList" :key="card.VDeviceId" :data="card" :select-type="selectType" @select="clickCard" />
    </div>
    <!-- 天幕子设备嵌套弹窗 -->
    <template v-if="showDeviceMsgDailog">
      <el-dialog :title="selectChildDevice.ChildName != '' ? selectChildDevice.ChildName + '-' + selectChildDevice.DeviceName : selectChildDevice.DeviceName" :visible.async="showDeviceMsgDailog" :modal-append-to-body="false" class="card_dialog" @close="DeviceMsgDailogColse" @before-close="DeviceMsgDailogColse">
        <button class="button_E330 buttonRefresh" :class="!isDoCardsetResresh ? 'button_eventNone_E330' : ''" @click="cardsetResresh">{{ $t('devicecard.refresh') }}&nbsp;<i :class="!isDoCardsetResresh ? 'el-icon-time' : 'el-icon-refresh'" /></button>
        <div v-loading="$store.state.isloadingdetail" class="card_set">
          <el-scrollbar class="new_scrollbar" style="height: 100%">
            <DeviceMsg :devicemodel="selectChildDevice" :is-exist-gs-device="isExistGsDevice" ref="DeviceMsgDailog" @replacedevice="replacedevice" @removedevice="removedevice" @deletedevice="deletedevice" @dosuccess="dosuccess" :childTiamMuDevice="true" />
          </el-scrollbar>
        </div>
      </el-dialog>
    </template>
  </div>
</template>
<script>
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue'
import { defineAsyncComponent } from 'vue'
export default {
  components: {
    OppleDeviceCard,
    DeviceMsg: defineAsyncComponent(() => import('@/components/common/deviceMsg.vue')),
  },
  props: {
    selectType: {
      type: Number,
      default: 0,
    },
    deviceCardList: {
      type: Array,
      default: () => [],
    },
    isExistGsDevice: {
      //是否存在格兰斯杯设备
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showDeviceMsgDailog(newVal) {
      if (newVal) {
        // 打开弹窗时，给 body 添加 class
        document.body.classList.add('dialog-open-global-style')
      } else {
        document.body.classList.remove('dialog-open-global-style')
        document.body.classList.add('dialog-close-global-style')
      }
      this.$parent && this.$parent.$emit('selectChildDevice', newVal)
    },
  },

  data() {
    return {
      isDoCardsetResresh: true,
      showDeviceMsgDailog: false,
      selectChildDevice: {},
    }
  },
  methods: {
    clickCard(item) {
      this.selectChildDevice = item
      this.showDeviceMsgDailog = true
    },
    cardsetResresh() {
      if (!this.isDoCardsetResresh) {
        return
      }
      this.isDoCardsetResresh = false
      let ardsetResreshTotalClock = window.setInterval(() => {
        this.ardsetResreshTotalTime--
        if (this.ardsetResreshTotalTime < 0) {
          window.clearInterval(ardsetResreshTotalClock)
          this.ardsetResreshTotalTime = 1000
          this.isDoCardsetResresh = true
        }
      })
      var dd = this.$refs.DeviceMsgDailog.mountedDo
      if (typeof dd == 'function') {
        dd(true)
      }
      dd = null
    },
    DeviceMsgDailogColse() {
      this.showDeviceMsgDailog = false
    },
    //替换
    replacedevice(model) {
      this.$parent && this.$parent.$emit('replacedevice', model)
    },
    //移动
    removedevice(model) {
      this.$parent && this.$parent.$emit('removedevice', model)
    },
    //删除
    deletedevice(model) {
      this.showDeviceMsgDailog = false
      this.$parent && this.$parent.deletedeviceCallback && this.$parent.deletedeviceCallback()
    },
    dosuccess() {
      this.showDeviceMsgDailog = false
      this.$parent && this.$parent.deletedeviceCallback && this.$parent.deletedeviceCallback()
    },
  },
}
</script>
<style lang="scss" scoped>
.device-tianmu-child-device {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .device-tianmu-child-device-container {
    display: flex;
    width: 100%;
    position: relative;
    flex-direction: row;
    overflow: auto;
    flex-wrap: wrap;
    .opple-device-card {
      margin-right: 15px;
      flex-shrink: 0;
      margin-bottom: 15px;
    }
  }
}
.card_dialog {
  .buttonRefresh {
    right: 60px;
    position: absolute;
    top: 18px;
    padding: 3px 8px;
  }
}
</style>

<style lang="css">
.dialog-open-global-style .v-modal {
  display: none !important;
}
.dialog-close-global-style .device-tianmu-child-device .v-modal {
  display: none !important;
}
</style>
